module.exports = __webpack_public_path__ + "u19.no2.97eb6dab.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/stories/kanai/u19.no2.jpg
// module id = fOzp
// module chunks = 0